export const phoneMedium = 375;
export const tablet = 768;
export const desktopMedium = 1024;
export const desktopLarge = 1200;

export const toPx = size =>
  size.toString().substring(size.length - 2) === 'px' ? size : `${size}px`;
export const minWidth = size => `@media (min-width: ${toPx(size)})`;



// WEBPACK FOOTER //
// ./app/screenSizes.js